import headBlack  from './head-black.png'
import headBeige  from './head-beige.png'
import headMint  from './head-mint.png'
import headOrange  from './head-orange.png'
import headPink  from './head-pink.png'
import headPurple  from './head-purple.png'
import headWhite  from './head-white.png'
import headYellow  from './head-yellow.png'
import headRed  from './head-red.png'
import headOlive  from './head-olive.png'
import headBlue  from './head-blue.png'

import neckBlack  from './neck-black.png'
import neckBeige  from './neck-beige.png'
import neckMint  from './neck-mint.png'
import neckOrange  from './neck-orange.png'
import neckPink  from './neck-pink.png'
import neckPurple  from './neck-purple.png'
import neckWhite  from './neck-white.png'
import neckYellow  from './neck-yellow.png'
import neckRed  from './neck-red.png'
import neckOlive  from './neck-olive.png'
import neckBlue  from './neck-blue.png'

import bodyBlack  from './body-black.png'
import bodyBeige  from './body-beige.png'
import bodyMint  from './body-mint.png'
import bodyOrange  from './body-orange.png'
import bodyPink  from './body-pink.png'
import bodyPurple  from './body-purple.png'
import bodyWhite  from './body-white.png'
import bodyYellow  from './body-yellow.png'
import bodyRed  from './body-red.png'
import bodyOlive  from './body-olive.png'
import bodyBlue  from './body-blue.png'


export const heads = [
    headWhite,
    headBlack,
    headBeige,
    headMint,
    headOrange,
    headPink,
    headPurple,
    headYellow,
    headOlive,
    headBlue,
    headRed
    
]

export const necks = [
    neckWhite,
    neckBlack,
    neckBeige,
    neckMint,
    neckOrange,
    neckPink,
    neckPurple,
    neckYellow,
    neckOlive,
    neckBlue,
    neckRed
 
]

export const bodys = [
    bodyWhite,
    bodyBlack,
    bodyBeige,
    bodyMint,
    bodyOrange,
    bodyPink,
    bodyPurple,
    bodyYellow,
    bodyOlive,
    bodyBlue,
    bodyRed
]